import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { CustomFields, filterCustomFieldsConfig } from "../../fields/CustomFields";
/* eslint-disable react/prop-types */

export const BasicInformationSectionExtraCmp = ({ record, customFieldsUI, formik }) => {
  const resourceType = formik.form.values.metadata.resource_type;
  const config = filterCustomFieldsConfig(customFieldsUI, "basic.extra", resourceType);
  return <CustomFields record={record} config={config} resourceType={resourceType} />;
};

BasicInformationSectionExtraCmp.propsTypes = {
  record: PropTypes.object.isRequired,
  customFieldsUI: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string.isRequired,
      displaySection: PropTypes.bool,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string.isRequired,
          ui_widget: PropTypes.string.isRequired,
          props: PropTypes.object,
        })
      ),
    })
  ).isRequired,
  formik: PropTypes.object.isRequired,
};

BasicInformationSectionExtraCmp.defaultProps = {
  resourceType: undefined,
};

export const BasicInformationSectionExtra = (props) => {
  return (
    <Field>
      {(formik) => <BasicInformationSectionExtraCmp formik={formik} {...props} />}
    </Field>
  );
};

BasicInformationSectionExtra.propsTypes = {
  record: PropTypes.object.isRequired,
  customFieldsUI: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string.isRequired,
      displaySection: PropTypes.bool,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string.isRequired,
          ui_widget: PropTypes.string.isRequired,
          props: PropTypes.object,
        })
      ),
    })
  ).isRequired,
};

BasicInformationSectionExtra.defaultProps = {};
